var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"headers":_vm.headers,"items":_vm.codes,"options":_vm.options,"server-items-length":_vm.total},on:{"update:options":function($event){_vm.options=$event},"click:row":_vm.onRowClicked},scopedSlots:_vm._u([{key:"item.type",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getCodeTypeText(item))+" ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getCodeStatusText(item))+" ")]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.localDateTime(item.createdAtDto))+" ")]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{attrs:{"small":"","disabled":!!item.processed,"title":"Oznacz w bazie jako usunięty."},on:{"click":function($event){return _vm.deleteCode(item, $event)}}},[_vm._v(" mdi-delete ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }